import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';

import './App.css';

import { Container, Button } from 'react-bootstrap';
import { loginRequest } from './_helpers/authConfig';

import Header from './_components/Header';
import Footer from './_components/Footer';
import BackupItems from './_components/BackupItems';
import Mails from './_components/Mails';
import Tools from './_components/Tools';

function App() {
  const { instance } = useMsal();

  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  return (
    <div className="App d-flex flex-column" style={{ height: '100vh' }}>
      <BrowserRouter>
        <Header />
        <Container fluid className="flex-grow-1 overflow-hidden py-3 d-flex flex-column">
          <AuthenticatedTemplate>
            <Routes>
              <Route path="/items" element={<BackupItems />} />
              <Route path="/mails" element={<Mails />} />
              <Route path="/tools" element={<Tools />} />

              {/* Add more routes as needed */}
              <Route path="*" element={<Navigate to="/items" />} />
            </Routes>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <div className="text-center mt-5">
              <Button 
                size="lg" 
                onClick={handleLoginRedirect}
                className="mt-3"
                style={{
                  backgroundColor: '#2F2F2F',
                  borderColor: '#2F2F2F',
                  color: '#FFFFFF',
                  fontWeight: '600',
                  padding: '12px 16px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '12px'
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                  <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                  <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                  <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                  <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
                </svg>
                Sign in with Microsoft
              </Button>
            </div>
          </UnauthenticatedTemplate>
        </Container>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
